import { post } from "jquery";
import Swal from "sweetalert2";
import { BlockPageHelper } from "../Helpers/helpers";
import { LibraryTreeManager } from "./LibraryTreeManager";
const Genesis = require("../Genesis.js");

interface IResult {
    message: string;
    status: number;
}

export class ISiteMobileDocumentUploadFilePage {
    private libraryTreeManager: LibraryTreeManager | null = null;
    constructor() { }
    public Init() {
        setTimeout(() => {
            this.libraryTreeManager = new LibraryTreeManager("#upload-document-library-tree", parseInt($("#recordTypeId").val() as string), true);
            this.libraryTreeManager.init();
        }, 1000);

        $(".backButton").click(_ => history.back());

        $("#uploadFile").click((e) => {            
            const libraryIds = this.getSelectedLibraries();            
            if ($("#fileUploadLibrarySelector").is(":visible"))
            {
                if (libraryIds.length === 0) {
                    Swal.fire({ text: "Please select a least one library to upload file too." })
                    return false;
                }
            }
            const MAX_FILESIZE_500MB = 524288000;
            const file: File | null = this.getFile();
            if (file === null) return false;
            if (file.size > MAX_FILESIZE_500MB) {
                Swal.fire({ text: `Max file upload size is 500MB, please select a smaller file.` });
                return false;
            }

            const recordId = $("#recordId").val();
            const isAssetCapture = $("#isAssetCapture").val() === "true";
            if (!isAssetCapture && recordId === "0") {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const pendingUploads = JSON.parse(localStorage.getItem("pendingUploads") || "[]");

                    pendingUploads.push({
                        fileName: file.name,
                        dataUrl: e.target?.result,
                        libraryIds,
                        timestamp: new Date().toISOString()
                    });

                    localStorage.setItem("pendingUploads", JSON.stringify(pendingUploads));
                    Swal.fire({ text: `File ${file.name} was uploaded successfully` });
                };
                reader.readAsDataURL(file);
            } else {
                const formData = this.compooseFormData(file, libraryIds);
                BlockPageHelper.block();
                post({
                    url: Genesis.url('Document/UploadFile'),
                    data: formData,
                    enctype: 'multipart/form-data',
                    processData: false,
                    contentType: false
                }).then((e: IResult) => {
                    this.resetForm();
                    BlockPageHelper.unblock();
                    if (e.status !== 200) {
                        Swal.fire({ text: `File ${file.name} failed to upload - ${e.message}` });
                        return;
                    }

                    Swal.fire({ text: `File ${file.name} was uploaded successfully` });
                }).fail((e: IResult) => {
                    BlockPageHelper.unblock();
                    Swal.fire({ text: `File ${file.name} failed to upload - ${e.message}` });
                }).catch(() => {
                    BlockPageHelper.unblock();
                    Swal.fire({ text: `File ${file.name} failed to upload` });
                });
            }
        });
    }

    private compooseFormData(file: File, libraryIds: number[]): FormData {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("recordId", ($("#recordId").val() as string));
        let recordId = $("#recordId").val();
        formData.append("secondaryId", ($("#secondaryId").val() as string));
        formData.append("libraryName", ($("#libraryName").val() as string));
        formData.append("fileTitle", ($("#fileTitle").val() as string));
        formData.append("updateMainImage", ($("#updateMainImage").val() as string));
        formData.append("isAssetCapture", ($("#isAssetCapture").val() as string));
        formData.append("libraryIds", libraryIds.toString());
        return formData;
    }

    private getFile(): File | null {
        const fileUpload = this.getUploadFile();
        let file: File;
        if (fileUpload !== null && fileUpload.files !== null && fileUpload.files.length > 0) {
            return fileUpload.files[0];
        }
        return null;
    }

    private getUploadFile(): HTMLInputElement | null {
        return document.querySelector('#upload-file');
    }

    private getSelectedLibraries(): number[] {
        let libraryIds: number[] = [];
        if (this.libraryTreeManager !== null) {
            libraryIds = this.libraryTreeManager.GetSelectedLibraries();
        }
        return libraryIds;
    }

    private resetForm(): void {
        const fileUpload = this.getUploadFile();
        if (fileUpload !== null) fileUpload.value = "";
        $(".upload-file-data").addClass("disabled");
        $("#fileTitleRow").addClass("disabled");
        $("#fileTitle").val('');
        const image: HTMLImageElement | null = document.querySelector('#image-data');
        if (image !== null) image.src = "";
    }
};